import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import LoadingButton from '../../skeletons/loadingButton';
import toast, { Toaster } from "react-hot-toast";
import { useEffect, useState } from 'react';
import '../../css/common.css';
import '../../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteForm, saveForm } from '../../store/Slices/formSlice';
import { generateLoa } from '../../store/Slices/generateSlice';
import useValidation from '../../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function English() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const email = sessionStorage.getItem('email');
    const generateLoading = useSelector((state) => state.generate.loading);

    useEffect(() => {
        const fetchData = async () => {

            if (!email) {
                navigate('/');
                return;
            }
            const text = localStorage.getItem('form');
            const form = text ? JSON.parse(text) : {};

            // if form data is present fill the form
            if (form?.country?.country === 'France') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const fillForm = (form) => {
        const jsonData = form;
        document.querySelector('#name').value = jsonData?.country?.customerDetails?.name ?? '';
        document.querySelector('#companyName').value = jsonData?.country?.customerDetails?.companyName ?? '';
        document.querySelector('#legalForm').value = jsonData?.country?.customerDetails?.legalForm ?? '';
        document.querySelector('#amount').value = jsonData?.country?.customerDetails?.amount ?? '';
        document.querySelector('#address').value = jsonData?.country?.customerDetails?.address ?? '';
        document.querySelector('#city').value = jsonData?.country?.customerDetails?.city ?? '';
        document.querySelector('#number').value = jsonData?.country?.customerDetails?.number ?? '';
        document.querySelector('#customerRole').value = jsonData?.country?.customerDetails?.customerRole ?? '';
        document.querySelector('#operator').value = jsonData?.country?.customerDetails?.operator ?? '';
        document.querySelector('#necessaryAct').value = jsonData?.country?.customerDetails?.necessaryAct ?? '';
        document.querySelector('#signature').value = jsonData?.country?.customerDetails?.signature ?? '';
        setName(jsonData?.country?.customerDetails?.name ?? '');
        setCompanyName(jsonData?.country?.customerDetails?.companyName ?? '');
        setLegalForm(jsonData?.country?.customerDetails?.legalForm ?? '');
        setAmount(jsonData?.country?.customerDetails?.amount ?? '');
        setAddress(jsonData?.country?.customerDetails?.address ?? '');
        setCity(jsonData?.country?.customerDetails?.city ?? '');
        setNumber(jsonData?.country?.customerDetails?.number ?? '');
        setCustomerRole(jsonData?.country?.customerDetails?.customerRole ?? '');
        setOperator(jsonData?.country?.customerDetails?.operator ?? '');
        setNecessaryAct(jsonData?.country?.customerDetails?.necessaryAct ?? '');
        setSignature(jsonData?.country?.customerDetails?.signature ?? '');

        document.querySelector('#sitesNumber').value = jsonData?.country?.site?.client?.sitesNumber ?? '';
        setSitesNumber(jsonData?.country?.site?.client?.sitesNumber ?? '');

        document.querySelector('#siteClient').value = jsonData?.country?.site?.client?.siteClient ?? '';
        setSiteClient(jsonData?.country?.site?.client?.siteClient ?? '');

        document.querySelector('#siteCompanyName').value = jsonData?.country?.site?.client?.siteCompanyName ?? '';
        setSiteCompanyName(jsonData?.country?.site?.client?.siteCompanyName ?? '');

        document.querySelector('#siteName').value = jsonData?.country?.site?.client?.siteName ?? '';
        setSiteName(jsonData?.country?.site?.client?.siteName ?? '');

        document.querySelector('#siteAddress').value = jsonData?.country?.site?.client?.siteAddress ?? '';
        setSiteAddress(jsonData?.country?.site?.client?.siteAddress ?? '');

        document.querySelector('#postalCode').value = jsonData?.country?.site?.client?.postalCode ?? '';
        setPostalCode(jsonData?.country?.site?.client?.postalCode ?? '');

        document.querySelector('#locality').value = jsonData?.country?.site?.client?.locality ?? '';
        setLocality(jsonData?.country?.site?.client?.locality ?? '');

        document.querySelector('#telephone').value = jsonData?.country?.site?.client?.telephone ?? '';
        setTelephone(jsonData?.country?.site?.client?.telephone ?? '');

        document.querySelector('#fax').value = jsonData?.country?.site?.client?.fax ?? '';
        setFax(jsonData?.country?.site?.client?.fax ?? '');

        document.querySelector('#idCode').value = jsonData?.country?.site?.client?.idCode ?? '';
        setIdCode(jsonData?.country?.site?.client?.idCode ?? '');

        document.querySelector('#siteOperator').value = jsonData?.country?.site?.client?.siteOperator ?? '';
        setSiteOperator(jsonData?.country?.site?.client?.siteOperator ?? '');

        document.querySelector('#tickbox').value = jsonData?.country?.site?.client?.tickbox ?? '';
        setTickbox(jsonData?.country?.site?.client?.tickbox ?? '');

        document.querySelector('#portability').value = jsonData?.country?.site?.client?.portability ?? '';
        setPortability(jsonData?.country?.site?.client?.portability ?? '');

        document.querySelector('#date').value = jsonData?.country?.portability?.dateAndTime?.date ?? '';
        document.querySelector('#time').value = jsonData?.country?.portability?.dateAndTime?.time ?? '';
        setDate(jsonData?.country?.portability?.dateAndTime?.date ?? '');
        setTime(jsonData?.country?.portability?.dateAndTime?.time ?? '');

        document.querySelector('#mainline').checked = jsonData?.country?.portability?.connectionType?.mainline ?? false;
        setIsMainline(jsonData?.country?.portability?.connectionType?.mainline ?? false);
        document.querySelector('#phoneNumber').value = jsonData?.country?.portability?.connectionType?.phoneNumber ?? '';

        setPhoneNumber(jsonData?.country?.portability?.connectionType?.phoneNumber ?? '');

        const numberOfTableRows = jsonData?.country?.portability?.connectionType?.DIDRange?.length;
        for (let i = 0; i < numberOfTableRows; i++) {
            addRow();
        }
        setTableData(jsonData?.country?.portability?.connectionType?.DIDRange);

        document.querySelector('#iName').value = jsonData?.country?.portability?.businessTelInstaller?.name ?? '';
        document.querySelector('#iAddress').value = jsonData?.country?.portability?.businessTelInstaller?.address ?? '';
        document.querySelector('#iTelephone').value = jsonData?.country?.portability?.businessTelInstaller?.telephone ?? '';
        setIName(jsonData?.country?.portability?.businessTelInstaller?.name ?? '');
        setIAddress(jsonData?.country?.portability?.businessTelInstaller?.address ?? '');
        setITelephone(jsonData?.country?.portability?.businessTelInstaller?.telephone ?? '');

        const RIOdetails = jsonData?.country?.portability?.rioDetails?.rio;
        if (Object.keys(RIOdetails).length !== 0) {
            setSelectedOption('yes');
            document.querySelector('#rio').value = 'yes';

            setTimeout(() => {
                const accessTypeRIO = document.querySelector('#accessTypeRIO');
                const numberRIO = document.querySelector('#numberRIO');
                const idRIO = document.querySelector('#idRIO');

                if (accessTypeRIO) {
                    accessTypeRIO.value = RIOdetails?.accessType;
                }
                if (numberRIO) {
                    numberRIO.value = RIOdetails?.number;
                }
                if (idRIO) {
                    idRIO.value = RIOdetails?.id;
                }
            }, 0);
            setFormData(RIOdetails);
        }
        else {
            setSelectedOption('no');
        }
    }

    //--------------------------------------validating form fields-------------------------------------//

    const { validateInput, validationStates, setValidationStates } = useValidation();

    //-----------------------------------initiating states---------------------------//

    const [name, setName] = useState();
    const [companyName, setCompanyName] = useState();
    const [legalForm, setLegalForm] = useState();

    const [amount, setAmount] = useState();
    const handleCapitalChange = (e) => {
        // Remove all non-digit characters except for the decimal point (if needed)
        const inputValue = e.target.value.replace(/[^\d.]/g, '');

        // Ensure there's at most one decimal point and properly format the input
        const parts = inputValue.split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Add commas for thousands

        // If there's a decimal part, join it back; otherwise, just return the integer part
        const formattedValue = parts[1] ? `${integerPart}.${parts[1]}` : integerPart;

        // Update the state with the formatted value
        setAmount(formattedValue);
    };

    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [number, setNumber] = useState();

    const [operator, setOperator] = useState();
    const [customerRole, setCustomerRole] = useState();
    const [necessaryAct, setNecessaryAct] = useState();
    const [signature, setSignature] = useState();

    const [date, setDate] = useState();
    const [time, setTime] = useState();

    const [isMainline, setIsMainline] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState();

    const [iName, setIName] = useState("");
    const [iAddress, setIAddress] = useState("");
    const [iTelephone, setITelephone] = useState("");

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------(Site Details)-----------------------------------//

    const [sitesNumber, setSitesNumber] = useState("");
    const [siteClient, setSiteClient] = useState("");
    const [siteCompanyName, setSiteCompanyName] = useState("");
    const [siteName, setSiteName] = useState("");
    const [siteAddress, setSiteAddress] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [locality, setLocality] = useState("");
    const [telephone, setTelephone] = useState("");
    const [fax, setFax] = useState("");
    const [idCode, setIdCode] = useState("");
    const [siteOperator, setSiteOperator] = useState("");
    const [tickbox, setTickbox] = useState("");
    const [portability, setPortability] = useState("");

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-based index = 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            const formattedDataRange = dataRows.map((row, index) => ({
                id: Date.now() + index, // Ensure unique ID
                DIDRangeStart: row[0] ? row[0].toString() : '',
                DIDRangeStop: row[1] ? row[1].toString() : '',
            }));

            setTableData(formattedDataRange);

            // Update only DID range related validation states, preserving others
            setValidationStates(prev => {
                const updatedStates = { ...prev };
                const numberRegex = /^\d{1,14}$/;

                formattedDataRange.forEach(row => {
                    updatedStates[`start-${row.id}`] = !!row.DIDRangeStart && numberRegex.test(row.DIDRangeStart);
                    updatedStates[`end-${row.id}`] = !!row.DIDRangeStop && numberRegex.test(row.DIDRangeStop);
                });

                return updatedStates;
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), DIDRangeStart: '', DIDRangeStop: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------code for rendering one section out of two (RIO Details)-------------------------//

    const [selectedOption, setSelectedOption] = useState('');
    const [formData, setFormData] = useState({

    });

    const handleDropdownChange = (e) => {
        setSelectedOption(e.target.value);
        // Reset form data when dropdown changes

        if (e.target.value === 'yes') {
            setFormData({
                accessType: "",
                number: "",
                id: ""
            })
        }
        else {
            setFormData({

            })
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const renderFormInputs = () => {
        switch (selectedOption) {
            case 'yes':
                return (
                    <div>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('accessType')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Access type*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='accessTypeRIO'
                                    name='accessType'
                                    placeholder=""
                                    className={`inputbox ${validationStates.accessTypeRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('accessTypeRIO', /^[\w\W,]+$/)}
                                />
                                {hoveredField === 'accessType' && (
                                    <div className="hover-description">
                                        Enter the access type
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('number')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Number*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='numberRIO'
                                    name='number'
                                    placeholder=""
                                    className={`inputbox ${validationStates.numberRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('numberRIO', /^\+?[1-9]\d{1,14}$/)}
                                />
                                {hoveredField === 'number' && (
                                    <div className="hover-description">
                                        Enter the number
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('id')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>RIO ID*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='idRIO'
                                    name='id'
                                    placeholder=""
                                    className={`inputbox ${validationStates.idRIO === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('idRIO', /^[\w\W,]+$/)}
                                />
                                {hoveredField === 'id' && (
                                    <div className="hover-description">
                                        Enter the RIO ID
                                    </div>
                                )}
                            </Col>
                        </Row>

                    </div>
                );
            case 'no':
                return (
                    <div></div>
                );
            default:
                return null;
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    // function to get Business Telephony Installer
    function getBusinessTelInstaller(iName, iAddress, iTelephone) {
        if (!iName && !iAddress && !iTelephone) {
            return {};
        }
        return {
            "name": iName,
            "address": iAddress,
            "telephone": iTelephone
        };
    }

    const json = {
        "country": {
            "country": "France",
            "customerDetails": {
                "name": name,
                "companyName": companyName,
                "legalForm": legalForm,
                "amount": amount,
                "address": address,
                "city": city,
                "number": number,
                "customerRole": customerRole,
                "operator": operator,
                "necessaryAct": necessaryAct,
                "signature": signature
            },
            "site": {
                "client": {
                    "sitesNumber": sitesNumber,
                    "siteClient": siteClient,
                    "siteCompanyName": siteCompanyName,
                    "siteName": siteName,
                    "siteAddress": siteAddress,
                    "postalCode": postalCode,
                    "locality": locality,
                    "telephone": telephone,
                    "fax": fax,
                    "idCode": idCode,
                    "siteOperator": siteOperator,
                    "tickbox": tickbox,
                    "portability": portability
                }
            },
            "portability": {
                "dateAndTime": {
                    "date": date,
                    "time": time
                },
                "connectionType": {
                    "mainline": isMainline,
                    "phoneNumber": phoneNumber,
                    "DIDRange": tableData
                },
                "businessTelInstaller": getBusinessTelInstaller(iName, iAddress, iTelephone),
                "rioDetails": {
                    "rio": formData
                }
            }
        },
        "email": sessionStorage.getItem('email'),
    }

    const jsonString = JSON.stringify(json);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Validate each field and set validation error with specific messages
        if (!name) {
            validationErrors.name = 'Please fill in the name.';
        }
        if (!companyName) {
            validationErrors.companyName = 'Please fill in the company name.';
        }
        if (!legalForm) {
            validationErrors.legalForm = 'Please fill in the legal form.';
        }
        if (!amount) {
            validationErrors.amount = 'Please fill in the amount.';
        }
        if (!address) {
            validationErrors.address = 'Please fill in the address.';
        }
        if (!city) {
            validationErrors.city = 'Please fill in the city.';
        }
        if (!number) {
            validationErrors.number = 'Please fill in the number.';
        }
        if (!customerRole) {
            validationErrors.customerRole = 'Please fill in the customer role.';
        }
        if (!operator) {
            validationErrors.operator = 'Please fill in the operator.';
        }
        if (!necessaryAct) {
            validationErrors.necessaryAct = 'Please specify the necessary act.';
        }
        if (!signature) {
            validationErrors.signature = 'Please fill in the signature location of the form';
        }
        if (!date) {
            validationErrors.date = 'Please fill in the date.';
        }
        if (!time) {
            validationErrors.time = 'Please fill in the time.';
        }
        if (!phoneNumber) {
            validationErrors.phoneNumber = 'Please fill in the idn.';
        }
        if (!sitesNumber) {
            validationErrors.sitesNumber = 'Please fill in the number of client sites.';
        }
        if (!siteCompanyName) {
            validationErrors.siteCompanyName = 'Please fill in the company name.';
        }
        if (!siteName) {
            validationErrors.siteName = 'Please fill in the name of representer.';
        }
        if (!siteAddress) {
            validationErrors.siteAddress = 'Please fill in the address.';
        }
        if (!postalCode) {
            validationErrors.postalCode = 'Please fill in the postal code.';
        }
        if (!locality) {
            validationErrors.locality = 'Please fill in the locality.';
        }
        if (!telephone) {
            validationErrors.telephone = 'Please fill in the telephone number.';
        }
        if (!fax) {
            validationErrors.fax = 'Please fill in the fax number.';
        }
        if (!idCode) {
            validationErrors.idCode = 'Please fill in the siret number.';
        }

        // Validate tableData DID ranges
        tableData.forEach(row => {
            const startId = `start-${row.id}`;
            const endId = `end-${row.id}`;

            if (!row.DIDRangeStart) {
                validationErrors[startId] = 'Please fill in the beginning of the DID range.';
            } else if (!/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStart)) {
                validationErrors[startId] = 'Please enter a valid starting DID number.';
            }

            if (!row.DIDRangeStop) {
                validationErrors[endId] = 'Please fill in the end of the DID range.';
            } else if (!/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStop)) {
                validationErrors[endId] = 'Please enter a valid ending DID number.';
            }
        });

        if (!selectedOption) {
            validationErrors.rio = 'Please specify whether RIO necessary or not.';
        }
        if (selectedOption === 'yes') {
            if (!formData.accessType) {
                validationErrors.accessTypeRIO = 'Please fill in the access type in RIO field.';
            }
            if (!formData.number) {
                validationErrors.numberRIO = 'Please fill in the number in RIO field.';
            }
            if (!formData.id) {
                validationErrors.idRIO = 'Please fill in the RIO ID.';
            }
        }

        // Combine keys from errors and current validationStates to update all validation flags
        const allKeys = new Set([
            ...Object.keys(validationErrors),
            ...Object.keys(validationStates)
        ]);

        let newValidationStates = {};
        allKeys.forEach(key => {
            newValidationStates[key] = !(key in validationErrors);
        });

        // Update validationStates state
        setValidationStates(newValidationStates);

        // Check if there are any validation errors
        const hasValidationError = Object.keys(validationErrors).length > 0;

        if (hasValidationError) {
            // Scroll to the first error and show toast
            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstError = validationErrors[firstErrorKey];
            const elem = document.getElementById(firstErrorKey);
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            }
            toast.error(firstError);
            return;
        }

        // Proceed with submission if no validation errors
        const data = jsonString; // your prepared JSON string for submission

        dispatch(generateLoa({ data, companyName })).then(response => {
            if (!response.error) {
                toast.success('LOA generated successfully');
            } else {
                window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
            }
        }).catch(() => {
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        });
    }

    //-------------------------------------------RESET & SAVE--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": email };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": email, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            console.error('Error downloading file: ', error);
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>Client Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter your name (e.g. BONGIBAULT)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('companyName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company Name*</label> <br />
                            <input
                                onChange={(e) => setCompanyName(e.target.value)}
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${validationStates.companyName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter your business name (e.g. AMEFO)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legalForm')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Legal Form*</label> <br />
                            <input
                                onChange={(e) => setLegalForm(e.target.value)}
                                type="text"
                                id="legalForm"
                                placeholder=""
                                className={`inputbox ${validationStates.legalForm === false ? 'error' : ''}`}
                                onBlur={() => validateInput('legalForm', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'legalForm' && (
                                <div className="hover-description">
                                    Enter your legal form (e.g. SAS)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('amount')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Capital amount in figures*</label> <br />
                            <input
                                value={amount}
                                onChange={handleCapitalChange} // Use the new change handler
                                type="text"
                                id="amount"
                                placeholder=""
                                className={`inputbox ${validationStates.amount === false ? 'error' : ''}`}
                                onBlur={() => validateInput('amount', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'amount' && (
                                <div className="hover-description">
                                    Enter the capital amount in figures (e.g. 584000)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address of Head Office*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter the head office address (e.g. 170 Quai Pasteur)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>RCS City*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter the Trade and Companies Register (e.g. CHAMBILLY)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('number')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Siren Number*</label> <br />
                            <input
                                onChange={(e) => setNumber(e.target.value)}
                                type="text"
                                id="number"
                                placeholder=""
                                className={`inputbox ${validationStates.number === false ? 'error' : ''}`}
                                onBlur={() => validateInput('number', /^\d{9}$/)}
                            />
                            {hoveredField === 'number' && (
                                <div className="hover-description">
                                    Enter the 9 digit siren number (e.g. 498252458)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('operator')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Current Operator*</label> <br />
                            <select
                                onChange={(e) => setOperator(e.target.value)}
                                id="operator"
                                className={`inputbox ${validationStates.operator === false ? 'error' : ''}`}
                                onBlur={() => validateInput('operator', /^[\w\W,]+$/)}
                            >
                                <option value=""></option>
                                <option value="4 connect">4 connect</option>
                                <option value="440HZ">440HZ</option>
                                <option value="8x8 UK Limited">8x8 UK Limited</option>
                                <option value="AB plus">AB plus</option>
                                <option value="Abaclouda">Abaclouda</option>
                                <option value="ADD-ON Consulting">ADD-ON Consulting</option>
                                <option value="Adenis">Adenis</option>
                                <option value="Aircall">Aircall</option>
                                <option value="Akinea Internet">Akinea Internet</option>
                                <option value="Alcacom">Alcacom</option>
                                <option value="Alpes networks">Alpes networks</option>
                                <option value="Alphalink">Alphalink</option>
                                <option value="Always on (ex Leonix Telecom)">Always on (ex Leonix Telecom)</option>
                                <option value="AMCS LLC">AMCS LLC</option>
                                <option value="Appliwave">Appliwave</option>
                                <option value="Atlasinvest OU">Atlasinvest OU</option>
                                <option value="Auranext (Emod)">Auranext (Emod)</option>
                                <option value="AVM Informatique">AVM Informatique</option>
                                <option value="Axialys">Axialys</option>
                                <option value="AZA Telecom">AZA Telecom</option>
                                <option value="BBS Informatique">BBS Informatique</option>
                                <option value="Bee Technology">Bee Technology</option>
                                <option value="Bersam telephone">Bersam telephone</option>
                                <option value="BICS">BICS</option>
                                <option value="BJT Partners">BJT Partners</option>
                                <option value="Bookline Solutions SL">Bookline Solutions SL</option>
                                <option value="Bouygues Telecom">Bouygues Telecom</option>
                                <option value="Bretagne Telecom">Bretagne Telecom</option>
                                <option value="Canal+ Telecom (ex Mediaserv)">Canal+ Telecom (ex Mediaserv)</option>
                                <option value="Capacom">Capacom</option>
                                <option value="Celeonet">Celeonet</option>
                                <option value="Celeste">Celeste</option>
                                <option value="Cloud telecom">Cloud telecom</option>
                                <option value="CM Telecom France">CM Telecom France</option>
                                <option value="CMRP">CMRP</option>
                                <option value="Colt">Colt</option>
                                <option value="Commentaires">Commentaires</option>
                                <option value="Completel (Entreprise)">Completel (Entreprise)</option>
                                <option value="Completel (GP)">Completel (GP)</option>
                                <option value="Completel (Opérateur)">Completel (Opérateur)</option>
                                <option value="Comunik CRM">Comunik CRM</option>
                                <option value="Connect managed services (UK) Limited">Connect managed services (UK) Limited</option>
                                <option value="Connectics">Connectics</option>
                                <option value="Coriolis (ex MYSTREAM)">Coriolis (ex MYSTREAM)</option>
                                <option value="Courrier">Courrier</option>
                                <option value="Destiny France Partenaires (ex OpenIP)">Destiny France Partenaires (ex OpenIP)</option>
                                <option value="Destiny global infra services">Destiny global infra services</option>
                                <option value="Dial once France">Dial once France</option>
                                <option value="Dialpad">Dialpad</option>
                                <option value="DIDWW Ireland Limited">DIDWW Ireland Limited</option>
                                <option value="Digicel">Digicel</option>
                                <option value="Digimium">Digimium</option>
                                <option value="Dimension Telecom">Dimension Telecom</option>
                                <option value="DVS Connect">DVS Connect</option>
                                <option value="Dynamik cloud & télécom">Dynamik cloud & télécom</option>
                                <option value="eGroup technologies AG">eGroup technologies AG</option>
                                <option value="Eis SRL">Eis SRL</option>
                                <option value="Elit Technologies">Elit Technologies</option>
                                <option value="email">email</option>
                                <option value="E-NEOLAB">E-NEOLAB</option>
                                <option value="ENREACH">ENREACH</option>
                                <option value="E-OLYMPE">E-OLYMPE</option>
                                <option value="Eurofiber France">Eurofiber France</option>
                                <option value="Even media interactive">Even media interactive</option>
                                <option value="EvolveIP Ltd">EvolveIP Ltd</option>
                                <option value="Eway">Eway</option>
                                <option value="Excentre">Excentre</option>
                                <option value="FC telecom">FC telecom</option>
                                <option value="Five9 GmbH">Five9 GmbH</option>
                                <option value="Flex network">Flex network</option>
                                <option value="Foliateam (ex Acropolis)">Foliateam (ex Acropolis)</option>
                                <option value="Fonitex technologie">Fonitex technologie</option>
                                <option value="Free">Free</option>
                                <option value="Free Pro (ex Jaguar Network)">Free Pro (ex Jaguar Network)</option>
                                <option value="Genesys cloud services BV">Genesys cloud services BV</option>
                                <option value="Get & go telecom">Get & go telecom</option>
                                <option value="Google Cloud France">Google Cloud France</option>
                                <option value="Goto technologies Ireland unlimited">Goto technologies Ireland unlimited</option>
                                <option value="Graphnet France">Graphnet France</option>
                                <option value="Groupe Convergence.com">Groupe Convergence.com</option>
                                <option value="GS Communication">GS Communication</option>
                                <option value="GTT COMMUNICATIONS France">GTT COMMUNICATIONS France</option>
                                <option value="Hexanet">Hexanet</option>
                                <option value="Hexatel">Hexatel</option>
                                <option value="Ibrowse">Ibrowse</option>
                                <option value="Idline">Idline</option>
                                <option value="Ikacom">Ikacom</option>
                                <option value="Infinivox">Infinivox</option>
                                <option value="Integraphone">Integraphone</option>
                                <option value="Iovox">Iovox</option>
                                <option value="IP Directions">IP Directions</option>
                                <option value="IP telecom Bulgaria Ltd">IP telecom Bulgaria Ltd</option>
                                <option value="Ipefix">Ipefix</option>
                                <option value="IPXTEL">IPXTEL</option>
                                <option value="ISI-COM">ISI-COM</option>
                                <option value="Kaisa Technologies AB">Kaisa Technologies AB</option>
                                <option value="Kav El International">Kav El International</option>
                                <option value="Keyyo">Keyyo</option>
                                <option value="K-net">K-net</option>
                                <option value="Koesio networks">Koesio networks</option>
                                <option value="Komeo">Komeo</option>
                                <option value="LAB SBH">LAB SBH</option>
                                <option value="Legos">Legos</option>
                                <option value="Lineconnects">Lineconnects</option>
                                <option value="Linkt">Linkt</option>
                                <option value="Longphone">Longphone</option>
                                <option value="Loopup Spain">Loopup Spain</option>
                                <option value="Lumen Technologies France">Lumen Technologies France</option>
                                <option value="Manifone">Manifone</option>
                                <option value="MASERGY COMMUNICATIONS UK Limited">MASERGY COMMUNICATIONS UK Limited</option>
                                <option value="Masselin communication">Masselin communication</option>
                                <option value="MCT">MCT</option>
                                <option value="Microsoft Ireland operations limited">
                                    Microsoft Ireland operations limited
                                </option>
                                <option value="Mixvoip S.A.">Mixvoip S.A.</option>
                                <option value="Morgon technologies">Morgon technologies</option>
                                <option value="Muona">Muona</option>
                                <option value="Mybestpro">Mybestpro</option>
                                <option value="Neotel">Neotel</option>
                                <option value="Netalis">Netalis</option>
                                <option value="Netiwan">Netiwan</option>
                                <option value="Nettel">Nettel</option>
                                <option value="Netwo">Netwo</option>
                                <option value="Nexera (ex Netcom Group)">Nexera (ex Netcom Group)</option>
                                <option value="Nexto - Fiducial Cloud">Nexto - Fiducial Cloud</option>
                                <option value="Nfon France">Nfon France</option>
                                <option value="NICE Systems UK Limited">NICE Systems UK Limited</option>
                                <option value="Nomotech (ex KERTEL)">Nomotech (ex KERTEL)</option>
                                <option value="Nordnet">Nordnet</option>
                                <option value="Novelcom">Novelcom</option>
                                <option value="NTT France">NTT France</option>
                                <option value="Nuwave Communications Limited">Nuwave Communications Limited</option>
                                <option value="NXO France">NXO France</option>
                                <option value="Occicom">Occicom</option>
                                <option value="Odigo (ex Prosodie)">Odigo (ex Prosodie)</option>
                                <option value="Onecentral BV">Onecentral BV</option>
                                <option value="Onoff telecom">Onoff telecom</option>
                                <option value="OPS Telecom">OPS Telecom</option>
                                <option value="Orange">Orange</option>
                                <option value="Orange Business Services">Orange Business Services</option>
                                <option value="Orange France">Orange France</option>
                                <option value="Orne THD">Orne THD</option>
                                <option value="OVEA">OVEA</option>
                                <option value="Oxilog">Oxilog</option>
                                <option value="Paritel Opérateur">Paritel Opérateur</option>
                                <option value="Peoplefone SAS">Peoplefone SAS</option>
                                <option value="Phibee Telecom (ex Chmurtz)">Phibee Telecom (ex Chmurtz)</option>
                                <option value="Phone.GS">Phone.GS</option>
                                <option value="Plug and tel">Plug and tel</option>
                                <option value="Prosoluce">Prosoluce</option>
                                <option value="Provectio">Provectio</option>
                                <option value="Pure IP Limited">Pure IP Limited</option>
                                <option value="Réseau concept">Réseau concept</option>
                                <option value="RETARUS GMBH">RETARUS GMBH</option>
                                <option value="Ringcentral France">Ringcentral France</option>
                                <option value="Rinkel B.V.">Rinkel B.V.</option>
                                <option value="RMI - Adista">RMI - Adista</option>
                                <option value="Sabio">Sabio</option>
                                <option value="SDCI">SDCI</option>
                                <option value="Serinya">Serinya</option>
                                <option value="Service distribution informatique Roca">
                                    Service distribution informatique Roca
                                </option>
                                <option value="Setera Communications Oy">Setera Communications Oy</option>
                                <option value="Sewan Communications">Sewan Communications</option>
                                <option value="SFR (DSO)">SFR (DSO)</option>
                                <option value="SFR (Entreprise)">SFR (Entreprise)</option>
                                <option value="SFR (GP)">SFR (GP)</option>
                                <option value="SFR Fibre SAS (ex Numericable)">SFR Fibre SAS (ex Numericable)</option>
                                <option value="Six degrees technology group Limited">
                                    Six degrees technology group Limited
                                </option>
                                <option value="Solutions Informatiques Services">
                                    Solutions Informatiques Services
                                </option>
                                <option value="Spacinov">Spacinov</option>
                                <option value="SRR (Entreprise)">SRR (Entreprise)</option>
                                <option value="SRR (GP)">SRR (GP)</option>
                                <option value="Stephie Telecom">Stephie Telecom</option>
                                <option value="Synelyans">Synelyans</option>
                                <option value="Talkcycle LLC DBA FrontSpin">Talkcycle LLC DBA FrontSpin</option>
                                <option value="TATA COMMUNICATIONS France">TATA COMMUNICATIONS France</option>
                                <option value="Teambox">Teambox</option>
                                <option value="Tel@ndcloud">Tel@ndcloud</option>
                                <option value="Telavox">Telavox</option>
                                <option value="Telecom Object">Telecom Object</option>
                                <option value="Trinaps">Trinaps</option>
                                <option value="Trustteam">Trustteam</option>
                                <option value="Twilio Ireland Limited">Twilio Ireland Limited</option>
                                <option value="Ty-line">Ty-line</option>
                                <option value="Ubefone (ex Telecom Studio)">Ubefone (ex Telecom Studio)</option>
                                <option value="Ubicentrex">Ubicentrex</option>
                                <option value="Unyc (ex Serveurcom)">Unyc (ex Serveurcom)</option>
                                <option value="VA Solutions">VA Solutions</option>
                                <option value="Verizon France">Verizon France</option>
                                <option value="Viadialog">Viadialog</option>
                                <option value="Voip telecom">Voip telecom</option>
                                <option value="Vonage BV">Vonage BV</option>
                                <option value="Voxnode">Voxnode</option>
                                <option value="VOYS">VOYS</option>
                                <option value="Watsoft distribution">Watsoft distribution</option>
                                <option value="Wildix EE OU">Wildix EE OU</option>
                                <option value="Worldline">Worldline</option>
                                <option value="Yoot IT">Yoot IT</option>
                                <option value="ZE telecom">ZE telecom</option>
                                <option value="Zeop">Zeop</option>
                                <option value="Zoom voice communications Inc.">Zoom voice communications Inc.</option>
                            </select>
                            {hoveredField === 'operator' && (
                                <div className="hover-description">
                                    Enter the current operator (e.g. BOUYGUES)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('customerRole')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Role in Organization*</label> <br />
                            <input
                                onChange={(e) => setCustomerRole(e.target.value)}
                                type="text"
                                id="customerRole"
                                placeholder=""
                                className={`inputbox ${validationStates.customerRole === false ? 'error' : ''}`}
                                onBlur={() => validateInput('customerRole', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'customerRole' && (
                                <div className="hover-description">
                                    Enter the customer's role in the organization (e.g. Director General)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('necessaryAct')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Necessary Act*</label> <br />
                            <select
                                id="necessaryAct"
                                onChange={(e) => setNecessaryAct(e.target.value)}
                                className={`inputbox ${validationStates.necessaryAct === false ? 'error' : ''}`}
                                onBlur={() => validateInput('necessaryAct', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="à la mise en œuvre de la portabilité">
                                    Implementation of Portability
                                </option>
                                <option value="à la résiliation de mon(mes) offre(s) sans mise en œuvre de la portabilité">
                                    Upon termination of my offer(s) without implementation of portability
                                </option>
                            </select>
                            {hoveredField === 'necessaryAct' && (
                                <div className="hover-description">
                                    Choose the necessary action
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Form Signature Location*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter the form signature location
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Site Details</h2> <br></br>

                    <div>
                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("siteClient")} onMouseLeave={handleMouseLeave}>
                                <label>Site Client</label> <br />
                                <input
                                    id="siteClient"
                                    type="text"
                                    name="siteClient"
                                    value={siteClient}
                                    onChange={(e) => setSiteClient(e.target.value)}
                                    className={`inputbox`}
                                //onBlur={() => validateInput("siteClient", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteClient" && <div className="hover-description">Enter the client site name</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("sitesNumber")} onMouseLeave={handleMouseLeave}>
                                <label>Number of client sites*</label> <br />
                                <input
                                    id="sitesNumber"
                                    type="text"
                                    name="sitesNumber"
                                    value={sitesNumber}
                                    onChange={(e) => setSitesNumber(e.target.value)}
                                    className={`inputbox ${validationStates["sitesNumber"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("sitesNumber", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "sitesNumber" && <div className="hover-description">Enter the number of client sites</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteCompanyName")} onMouseLeave={handleMouseLeave}>
                                <label>Company Name*</label> <br />
                                <input
                                    id="siteCompanyName"
                                    type="text"
                                    name="siteCompanyName"
                                    value={siteCompanyName}
                                    onChange={(e) => setSiteCompanyName(e.target.value)}
                                    className={`inputbox ${validationStates["siteCompanyName"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteCompanyName", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteCompanyName" && <div className="hover-description">Enter the company name</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteName")} onMouseLeave={handleMouseLeave}>
                                <label>Represented by*</label> <br />
                                <input
                                    id="siteName"
                                    type="text"
                                    name="siteName"
                                    value={siteName}
                                    onChange={(e) => setSiteName(e.target.value)}
                                    className={`inputbox ${validationStates["siteName"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteName", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteName" && <div className="hover-description">Enter the representative's name</div>}
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("siteAddress")} onMouseLeave={handleMouseLeave}>
                                <label>Address*</label> <br />
                                <input
                                    id="siteAddress"
                                    type="text"
                                    name="siteAddress"
                                    value={siteAddress}
                                    onChange={(e) => setSiteAddress(e.target.value)}
                                    className={`inputbox ${validationStates["siteAddress"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("siteAddress", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "siteAddress" && <div className="hover-description">Enter the address</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("postalCode")} onMouseLeave={handleMouseLeave}>
                                <label>Postal Code*</label> <br />
                                <input
                                    id="postalCode"
                                    type="text"
                                    name="postalCode"
                                    value={postalCode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                    className={`inputbox ${validationStates["postalCode"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("postalCode", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "postalCode" && <div className="hover-description">Enter the postal code</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("locality")} onMouseLeave={handleMouseLeave}>
                                <label>Locality*</label> <br />
                                <input
                                    id="locality"
                                    type="text"
                                    name="locality"
                                    value={locality}
                                    onChange={(e) => setLocality(e.target.value)}
                                    className={`inputbox ${validationStates["locality"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("locality", /^[\w\W,]+$/)}
                                />
                                {hoveredField === "locality" && <div className="hover-description">Enter the locality</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("telephone")} onMouseLeave={handleMouseLeave}>
                                <label>Telephone Number*</label> <br />
                                <input
                                    id="telephone"
                                    type="text"
                                    name="telephone"
                                    value={telephone}
                                    onChange={(e) => setTelephone(e.target.value)}
                                    className={`inputbox ${validationStates["telephone"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("telephone", /^\+?[1-9]\d{1,14}$/)}
                                />
                                {hoveredField === "telephone" && <div className="hover-description">Enter the telephone number</div>}
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("fax")} onMouseLeave={handleMouseLeave}>
                                <label>Email Address*</label> <br />
                                <input
                                    id="fax"
                                    type="text"
                                    name="fax"
                                    value={fax}
                                    onChange={(e) => setFax(e.target.value)}
                                    className={`inputbox ${validationStates["fax"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("fax", /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$/)}
                                />
                                {hoveredField === "fax" && <div className="hover-description">Enter the Email Address</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("idCode")} onMouseLeave={handleMouseLeave}>
                                <label>Siret number*</label> <br />
                                <input
                                    id="idCode"
                                    type="text"
                                    name="idCode"
                                    value={idCode}
                                    onChange={(e) => setIdCode(e.target.value)}
                                    className={`inputbox ${validationStates["idCode"] === false ? "error" : ""}`}
                                    onBlur={() => validateInput("idCode", /^\d{14}$/)}
                                />
                                {hoveredField === "idCode" && <div className="hover-description">Enter the 14-digit Siret number</div>}
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("siteOperator")} onMouseLeave={handleMouseLeave}>
                                <label>Current Operator</label> <br />
                                <input
                                    id="siteOperator"
                                    type="text"
                                    name="siteOperator"
                                    value={operator}
                                    onChange={(e) => setSiteOperator(e.target.value)}
                                    className="inputbox"
                                />
                                {hoveredField === "siteOperator" && <div className="hover-description">Enter the current operator</div>}
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            <Col onMouseEnter={() => handleMouseEnter("tickbox")} onMouseLeave={handleMouseLeave}>
                                <label>Select an option</label> <br />
                                <select name="tickbox" id="tickbox" value={tickbox} onChange={(e) => setTickbox(e.target.value)} className="inputbox">
                                    <option value=""></option>
                                    <option value="Pre-selection Offer">Pre-selection Offer</option>
                                    <option value="Partial Unbundling">Partial Unbundling</option>
                                    <option value="DSL Access">DSL Access</option>
                                </select>
                            </Col>

                            <Col onMouseEnter={() => handleMouseEnter("portability")} onMouseLeave={handleMouseLeave}>
                                <label>Portability of the numbers</label> <br />
                                <select name="portability" id="portability" value={portability} onChange={(e) => setPortability(e.target.value)} className="inputbox">
                                    <option value=""></option>
                                    <option value="Partielle">Partial</option>
                                    <option value="Compléte">Complete</option>
                                </select>
                            </Col>
                        </Row>

                    </div>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Date and Time</h2> <br></br>
                    <h6 className='heading'>**Acceptance of time is subject to the availability of the portage team.</h6>


                    <Row>
                        <Col>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date} // Automatically set the current date
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                        </Col>

                        <Col>
                            <label>Time*</label> <br></br>
                            <input
                                onChange={(e) => setTime(e.target.value)}
                                type="time"
                                id='time'
                                placeholder=""
                                className={`inputbox ${validationStates.time === false ? 'error' : ''}`}
                                onBlur={() => validateInput('time', /^.*$/)}
                            />
                        </Col>
                        <Col>
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Connection Type</h2> <br></br>

                    <Row>

                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="mainline"
                                    name="mainline"
                                    checked={isMainline} // Bind state to checked attribute
                                    onChange={(e) => setIsMainline(e.target.checked)} // Handle checkbox change                
                                />
                                <label htmlFor="mainline">&nbsp; Is mainline number porting also required</label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('phoneNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>IDN*</label> <br />
                            <input
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                type="text"
                                id='phoneNumber'
                                placeholder=""
                                className={`inputbox ${validationStates.phoneNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('phoneNumber', /^\+?[1-9]\d{1,14}$/)}
                            />
                            {hoveredField === 'phoneNumber' && (
                                <div className="hover-description">
                                    Enter IDN (installation designation number)
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>DID first number in range*</th>
                                <th>DID last number in range*</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row) => (
                                <tr key={row.id}>
                                    <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`}
                                            value={row.DIDRangeStart}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'DIDRangeStart', value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`start-${row.id}`]: /^\+?[1-9]\d{0,13}$/.test(value),
                                                }));
                                            }}
                                            onBlur={() => {
                                                if (row.DIDRangeStart && !/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStart)) {
                                                    toast.error('Number must be between 1 to 14 digits');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`}
                                            value={row.DIDRangeStop}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'DIDRangeStop', value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`end-${row.id}`]: /^\+?[1-9]\d{0,13}$/.test(value),
                                                }));
                                            }}
                                            onBlur={() => {
                                                if (row.DIDRangeStop && !/^\+?[1-9]\d{0,13}$/.test(row.DIDRangeStop)) {
                                                    toast.error('Number must be between 1 to 14 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Business Telephony Installer</h2> <br></br>
                    <h6 className='heading'>**This section is optional and can be left empty</h6>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('iName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name</label> <br />
                            <input
                                onChange={(e) => setIName(e.target.value)}
                                type="text"
                                id='iName'
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'iName' && (
                                <div className="hover-description">
                                    Enter your name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('iAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Address</label> <br />
                            <input
                                onChange={(e) => setIAddress(e.target.value)}
                                type="text"
                                id='iAddress'
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'iAddress' && (
                                <div className="hover-description">
                                    Entrer your address
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('iTelephone')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Telephone</label> <br />
                            <input
                                onChange={(e) => setITelephone(e.target.value)}
                                type="text"
                                id='iTelephone'
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'iTelephone' && (
                                <div className="hover-description">
                                    Enter your phone number
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>RIO Details</h2> <br></br>

                    <Row>
                        <Col xs={8}>
                            <label>Is RIO Necessary*</label> <br></br>
                            <select
                                id="rio"
                                value={selectedOption}
                                onChange={handleDropdownChange}
                                className={`inputbox ${validationStates.rio === false ? 'error' : ''}`}
                                onBlur={() => validateInput('rio', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="no">No</option>
                                <option value="yes">Yes</option>
                            </select>
                            <br></br>
                            {renderFormInputs()}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <LoadingButton
                        variant="primary"
                        type="submit"
                        onClick={Submit}
                        isLoading={generateLoading}
                    >
                        Generate LOA
                    </LoadingButton>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>

            </div>

        </div>
    );
}

export default English;